// Debug logging utility
// Read from environment variable, default to 0 (no debug logs) if not set
// Set to 1 to enable basic debug logs
export const DEBUG_LOGGING_LEVEL = process.env.NODE_ENV === 'production' 
  ? 0 
  : parseInt(process.env.REACT_APP_DEBUG_LOGGING_LEVEL || '0', 10);

/**
 * Conditional console.log based on debug level
 * @param requiredLevel - Minimum debug level required to show this log
 * @param args - Arguments to pass to console.log
 */
export const debugLog = (requiredLevel: number, ...args: any[]) => {
  if (DEBUG_LOGGING_LEVEL >= requiredLevel) {
    console.log(...args);
  }
};

/**
 * Always shows errors regardless of debug level
 * @param args - Arguments to pass to console.error
 */
export const debugError = (...args: any[]) => {
  console.error(...args);
};
